module.exports = __webpack_public_path__ + "assets/img/twokonggou.dd953ab7.jpg";